import React, { FC } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
// import CloseIcon from "@mui/material/icons/Close";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { OnSubmitInput } from "../../common/model/EventModels";
import { Callback } from "../../common/model/Callbacks";

type Props = {
  deleteError: string;
  handleSubmit: OnSubmitInput;
  error: any;
  handleRadioChange: Callback;
  radioValue: string;
};

export const DeleteAccount: FC<Props> = ({
  deleteError,
  handleSubmit,
  error,
  handleRadioChange,
  radioValue
}) => {
  return (
    <div className="security__change_password">
      <h3>Delete Account</h3>
      {deleteError !== "" && (
        <Chip
          size="medium"
          label={deleteError}
          disabled
          // icon={<CloseIcon />}
          style={{ color: "#FF0000", width: "260px", margin: "1rem 0" }}
          variant="outlined"
        />
      )}
      <form onSubmit={handleSubmit}>
        <FormControl component="fieldset" error={error}>
          <span>
            By deleting your accout you will also delete all the data that is
            assosiated with your account and this action can not be undone. Are
            your sure you want to delete your account?
          </span>
          <RadioGroup
            aria-label="delete account"
            name="delete account"
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="yes"
              control={<Radio />}
              label="Yes, I am."
            />
          </RadioGroup>
          <Button
            type="submit"
            variant="outlined"
            disabled={Boolean(radioValue === null)}
          >
            Delete My Account
          </Button>
        </FormControl>
      </form>
    </div>
  );
};
